const CUSTOMER_WORKFLOW = {
  CADASTRO_ENVIADO: {
    id: 1,
    description: 'Cadastro enviado',
    icon: 'PhPaperPlaneRight',
    next: () => {
      return [CUSTOMER_WORKFLOW.CADASTRO_EM_ANDAMENTO, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO];
    },
  },
  CADASTRO_EM_ANDAMENTO: {
    id: 2,
    description: 'Cadastro em andamento',
    icon: 'PhNotePencil',
    method: 'updateStatusToInProgress',
    next: () => {
      return [CUSTOMER_WORKFLOW.AGUARDANDO_ANALISE, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO, CUSTOMER_WORKFLOW.CADASTRO_ENVIADO];
    },
  },
  AGUARDANDO_ANALISE: {
    id: 3,
    description: 'Aguardando análise',
    icon: 'PhClock',
    method: 'updateStatusToWaitingAnalysis',
    next: () => {
      return [CUSTOMER_WORKFLOW.CADASTRO_EM_ANALISE, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO, CUSTOMER_WORKFLOW.CADASTRO_ENVIADO];
    },
  },
  CADASTRO_EM_ANALISE: {
    id: 4,
    description: 'Cadastro em análise',
    icon: 'PhMagnifyingGlass',
    method: 'updateStatusToInAnalysis',
    next: () => {
      return [CUSTOMER_WORKFLOW.PENDECIA, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO, CUSTOMER_WORKFLOW.FINALIZADO, CUSTOMER_WORKFLOW.CADASTRO_RECUSADO, CUSTOMER_WORKFLOW.CADASTRO_ENVIADO];
    },
  },
  PENDECIA: {
    id: 5,
    description: 'Pendência',
    icon: 'PhWarning',
    method: 'updateStatusToPendency',
    next: () => {
      return [CUSTOMER_WORKFLOW.PENDECIA, CUSTOMER_WORKFLOW.CADASTRO_EM_ANALISE, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO, CUSTOMER_WORKFLOW.FINALIZADO, CUSTOMER_WORKFLOW.CADASTRO_RECUSADO, CUSTOMER_WORKFLOW.CADASTRO_ENVIADO];
    },
  },
  ATUALIZACAO_CADASTRAL: {
    id: 6,
    description: 'Atualização cadastral',
    icon: 'PhArrowsClockwise',
    method: null,
    next: () => {
      return [CUSTOMER_WORKFLOW.CADASTRO_EM_ANDAMENTO, CUSTOMER_WORKFLOW.CADASTRO_INATIVADO, CUSTOMER_WORKFLOW.CADASTRO_ENVIADO];
    },
  },
  FINALIZADO: {
    id: 7,
    description: 'Finalizado',
    icon: 'PhCheckCircle',
    method: 'updateStatusToFinished',
    next: () => {
      return [CUSTOMER_WORKFLOW.ATUALIZACAO_CADASTRAL, CUSTOMER_WORKFLOW.PENDECIA, CUSTOMER_WORKFLOW.CADASTRO_ENVIADO];
    },
  },
  CADASTRO_RECUSADO: {
    id: 8,
    description: 'Cadastro recusado',
    icon: 'PhXCircle',
    method: 'updateStatusToRejected',
    next: () => {
      return [CUSTOMER_WORKFLOW.ATUALIZACAO_CADASTRAL, CUSTOMER_WORKFLOW.CADASTRO_ENVIADO];
    },
  },
  CADASTRO_INATIVADO: {
    id: 9,
    description: 'Cadastro inativado',
    icon: 'PhMinusCircle',
    method: 'updateStatusToInactivated',
    next: () => {
      return [CUSTOMER_WORKFLOW.ATUALIZACAO_CADASTRAL, CUSTOMER_WORKFLOW.CADASTRO_ENVIADO];
    },
  },
  SOCIO: {
    id: 11,
    description: 'Sócio',
    next: () => {
      return [];
    },
  },
}

const CUSTOMER_WORKFLOW_LIST = Object.values(CUSTOMER_WORKFLOW);

const CUSTOMER_REACTIVATION = {
  fromStatusIds: [CUSTOMER_WORKFLOW.CADASTRO_INATIVADO.id, CUSTOMER_WORKFLOW.CADASTRO_RECUSADO.id],
  targetStatusIds: [CUSTOMER_WORKFLOW.FINALIZADO.id, CUSTOMER_WORKFLOW.CADASTRO_EM_ANALISE.id],
};

const canReactivateCustomer = (statusId) => CUSTOMER_REACTIVATION.fromStatusIds.includes(Number(statusId));

export  {
  CUSTOMER_WORKFLOW,
  CUSTOMER_WORKFLOW_LIST,
  CUSTOMER_REACTIVATION,
  canReactivateCustomer,
}